import { GetHDFCtoHDFCReport } from "../../../../Helpers/APIEndPoints/EndPoints";
import YearlyCommonDashboard from "../YearlyCommonDashboard/YearlyCommonDashboard";

const HDFCToHDFCReport = () => {
  return (
    <>
      <YearlyCommonDashboard
        PageName="HDFCToHDFC"
        ExportToExcelUrl={GetHDFCtoHDFCReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default HDFCToHDFCReport;
